<template>
    <span :class="outlined ? 'material-icons-outlined' : 'material-icons'">
        {{ icon }}
    </span>
</template>

<script>
export default {
    props: {
        outlined: {
            required: false,
            default: false,
            type: Boolean
        },
        icon: String
    }
}
</script>
